import React from 'react';
import { buildUrlAndOpenWindow } from 'app/utilities/StringHelpers/StringHelpers';

function HelpText({ status, cmsTextData, issueOrjobResolved, isDelay }) {
 const {
   helptext,
   restartInternetText
 } = cmsTextData;

 const isResolved = issueOrjobResolved && !isDelay;
 const text = isResolved ? restartInternetText : helptext;

 return (
<div className="help-text">
  {text && (
    <div dangerouslySetInnerHTML={{ __html: text }} />
  )}
</div>
 );
}

export default HelpText;
